import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class CrmLeadService extends Service {
	constructor(injector: Injector) {
		super("CrmLead", injector);
	}

	generateClientFromLead(leadId: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/GenerateClientFromLead/${leadId}`, {});
	}

	generateLeadFromClient(clientId: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/GenerateLeadFromClient/${clientId}`, {});
	}

	getByAssignedUserId(userId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByAssignedUserId/${userId}`);
	}

	getByStatus(status: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByStatus/${status}`);
	}

	toggleActive(leadId: number) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/ToggleActive/${leadId}`, {});
	}
}
